var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sale-detail" },
    [
      _c("sale-info", {
        staticClass: "sale-info-1",
        attrs: { sale: _vm.sale }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "sale-info-2" }, [
        _c("div", { staticClass: "sale-name" }, [
          _vm._v(_vm._s(_vm.sale.saleName))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "sale-content" }, [
          _vm._v(_vm._s(_vm.sale.content))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sale-info-3" }, [
        _c("div", [
          _c("table", [
            _c("tbody", [
              _c("tr", [
                _c("td", {}, [_vm._v("募集期間")]),
                _vm._v(" "),
                _c("td", {}, [
                  _vm._v(
                    _vm._s(
                      _vm.formatDate(
                        _vm.sale.applicationPeriodFrom,
                        _vm.sale.applicationPeriodTo
                      )
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", {}, [_vm._v("開催期間")]),
                _vm._v(" "),
                _c("td", {}, [
                  _vm._v(
                    _vm._s(
                      _vm.formatDate(
                        _vm.sale.eventPeriodFrom,
                        _vm.sale.eventPeriodTo
                      )
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", {}, [_vm._v("参加条件")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.sale.target))])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-gray" }, [
            _vm._v("セールID：" + _vm._s(_vm.sale.saleId))
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-073f83ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-073f83ca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/sale/components/SaleDetail.vue
// module id = null
// module chunks = 